import { IS_SSR } from 'src/utils/helpers.utils';

export const useIsWebpSupported = () => IS_SSR ? true : !!window.isWebpSupport;
